/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, typography } from '@atlaskit/theme';

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const PanelHeaderWrapper = styled.div`
  display: flex;
`;

export const BranchSyncInfoWrapper = styled.div`
  margin-left: ${gridSize()}px;
`;

export const CommitListHeading = styled.h2`
  ${typography.h400() as any};
  margin-top: 0;
`;

export const CommitList = styled.section`
  margin: 0 auto;
`;
